module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020ZH-11.027aa888.jpg";